import { useState, type ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  rightAdornment?: ReactNode;
  onReset?: () => void;
}

export function SectionCard({ title, children, defaultOpen = true, rightAdornment, onReset }: SectionCardProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <div className="flex items-center justify-between gap-2 border-b border-slate-100 px-4 py-2.5 dark:border-slate-800">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="flex flex-1 items-center gap-2 text-left text-sm font-semibold text-slate-800 dark:text-slate-100"
          aria-expanded={open}
        >
          <span className={`transition-transform ${open ? 'rotate-90' : ''}`}>›</span>
          {title}
        </button>
        <div className="flex items-center gap-2">
          {rightAdornment}
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              className="text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
              title={`Reset ${title} to defaults`}
            >
              Reset
            </button>
          )}
        </div>
      </div>
      {open && <div className="space-y-3 p-4">{children}</div>}
    </div>
  );
}
